export enum ScheduleMode {
  DAY,
  WEEK,
}

export const NEXT_DAY_EVENT_LABEL = 'The next day with events is ';
export const LAST_DAY_EVENT_LABEL = 'The last day with events was ';

export const CANCEL_EVENT_MODAL = {
  cancelButtonLabel: 'Back',
  confirmButtonLabel: 'Cancel event',
  message:
    'Are you sure you want to cancel this event? This will remove the event for all registrants.',
  title: 'Cancel Event',
};

export const EDIT_ERRORS = {
  newDateGreaterThanOldEndDate:
    'The selected date and time is after the end of the current series. Please choose an earlier date and time or create a new recurring appointment series for this patient.',
};

export enum ParticipantTypes {
  HOST = 'host',
  SUPPORT = 'support',
  PATIENT = 'patient',
  PROVIDER = 'provider',
}
